import React from 'react';

import ModalPopup from '@/src/components/common/Elements/Modal/ModalPopup/ModalPopup';

// import './index.scss';

const ConfirmModal = (props) => {
  const { type, onCancel, onRename } = props;

  const handleRename = () => {
    onRename();
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <ModalPopup
      id={'confirmRenameFile'}
      title={`Rename ${type} ?`}
      message={`A ${type} with the same name already exists. Do you wish to proceed with renaming the ${type}?`}
      onConfirm={handleRename}
      onClose={handleCancel}
    />
  );
};

export default ConfirmModal;
